import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface SlideColumnProps {
  title: string;
  subtitle: ReactNode;
  children: ReactNode;
}

const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

const StyledColumnHeader = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.small};
`;

const StyledColumnTitle = styled.h3`
  margin: 0;
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize.body};
  color: ${({ theme }) => theme.palette.text};
`;

const StyledColumnSubtitle = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.palette.textDimmed};
`;

const StyledSlideList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  max-height: 60vh;
  overflow-y: auto;
  padding-right: ${({ theme }) => theme.spacing.small};
`;

export const formatSlideCount = (count: number) => `${count} slide${count === 1 ? '' : 's'}`;

export const SlideColumn: FC<SlideColumnProps> = ({ title, subtitle, children }) => (
  <StyledColumn>
    <StyledColumnHeader>
      <StyledColumnTitle>{title}</StyledColumnTitle>
      <StyledColumnSubtitle>{subtitle}</StyledColumnSubtitle>
    </StyledColumnHeader>

    <StyledSlideList>{children}</StyledSlideList>
  </StyledColumn>
);
